// Copyright (c) 2017 Deere & Company

import DealerHierarchyTerritory from './dealer-hierarchy-territory';
import t from 'tcomb';

const DealerHierarchy = t.list(DealerHierarchyTerritory, 'DealerHierarchy');

export const getDefaultState = () => new DealerHierarchy([]);

export default DealerHierarchy;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/dealer-hierarchy.js